var map = {
	"./about.js": "7ad2",
	"./business.js": "aeb6",
	"./core.js": "5305",
	"./data.js": "c753",
	"./fanhanapp.js": "b760",
	"./headfoot.js": "aab7",
	"./platform.js": "9053",
	"./public.js": "80d2",
	"./resource.js": "f1c2",
	"./service.js": "5bcc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7a70";